export const CIVIL_CHECKLIST = "CIVIL_CHECKLIST";
export const FIRST_INTERACTION_FORM = "FIRST_INTERACTION_FORM";
export const CONFIGURATION_TESTING = "CONFIGURATION_TESTING";
export const VALET_GO_LIVE = "VALET_GO_LIVE";
export const DASHBOARD_TRAINING = "DASHBOARD_TRAINING";
export const DASHBOARD_TRAINING_CHK_DETAILS = "DASHBOARD_TRAINING_CHK_DETAILS";
